/**
 * @name 태양광발전정보
 * @description
 */

import {useAppSelector} from 'model'
import {actions, EVENT, POPUP} from 'model/modules/solar'
export {default} from './container'
//*--------------------------------------------------*
/**
 * @name config
 * @description Redux Action, Mode, Event, Popup
 */
export const Store = () => useAppSelector(state => state.solar)
export const _action = actions
export const _event = EVENT
export const _popup = POPUP

/********************************************************

*********************************************************/
